var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { BasePanel } from '../common/basePanel';
import { QueuePanel } from '../common/queuePanel';
import { StepContainer, StepPanel } from '../common/stepContainer';
import { LearningCurveAccordion } from '../learningCurve';
import { LocationTable } from '../locationTable';
import { QueueStatusType } from '../queue/types';
import { usePlanType, useQueueLocations } from '../selectors';
export var HandleTimeContent = function () {
  return _jsx(LocationTable, {
    name: "handleTime",
    min: 1,
    max: 99999,
    addColumns: ['Average'],
    showGroupHeader: true
  });
};
export var HandleTimeStep = function () {
  var t = useTranslation('wizard', {
    keyPrefix: 'handleTime'
  }).t;
  var planType = usePlanType();
  var queueLocations = useQueueLocations();
  var description = queueLocations.length ? t('locationMessage', {
    planType: planType
  }) : t('message', {
    planType: planType
  });
  return _jsx(StepContainer, __assign({
    leftContent: _jsx(QueuePanel, {})
  }, {
    children: _jsxs(StepPanel, {
      children: [_jsx(BasePanel, __assign({
        title: t('title'),
        description: description,
        statusType: QueueStatusType.HandleTime,
        needSaveBeforeCopy: true
      }, {
        children: _jsx(HandleTimeContent, {})
      })), _jsx(LearningCurveAccordion, {})]
    })
  }));
};